import React from 'react'
import { Grid } from '@mui/material'
import ProfileMenu from '../../components/ProfileMenu'
import { Helmet } from 'react-helmet-async'
import ProfileTransaction from '../../components/ProfileTransaction'

const TransactionHistoryPage = () => {
  // TODO: hiện tại mới hiển thị history của deposit, cần thêm history của withdraw

  return (
    <>
      <Helmet>
        <meta charSet="utf-8" />
        <title>Lịch sử giao dịch | Zest.win</title>
      </Helmet>
      <Grid container spacing={2} sx={{ maxWidth: '900px', margin: 'auto' }}>
        <Grid item md={3}>
          <ProfileMenu />
        </Grid>
        <Grid item md={9}>
          <ProfileTransaction />
        </Grid>
      </Grid>
    </>
  )
}

export default TransactionHistoryPage
